module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "1950798677",
      "ad-style": "display:inline-block;width:468px;height:60px",
      "ad-format": "auto"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n        Consider our All Sports Packages for your one stop shop sports betting\n        needs. We offer expertise in College football picks, NFL football\n        picks, college basketball picks, college football predictions, Free\n        basketball picks, MLB Picks, sports betting advice, free football\n        picks.\n      ")]), _vm._v(" "), _vm._l((_vm.ps), function(p) {
    return _c('h5', {
      key: p.id
    }, [_vm._v("\n        " + _vm._s(p.name) + "\n        "), _c('purchase-button', {
      attrs: {
        "package": p,
        "full-width": "true"
      }
    })], 1)
  }), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "1950798677",
      "ad-style": "display:inline-block;width:468px;height:60px",
      "ad-format": "auto"
    }
  })], 2), _vm._v(" "), _c('sidebar', {
    attrs: {
      "packages": _vm.packages
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bc681a88!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Package.vue
// module id = 525
// module chunks = 1